import React from 'react';
import { Card, CardBody } from '@nextui-org/react';
import { Target } from 'lucide-react';
import { SeasonHighFinishEntry } from '../../services/statsExplorerService';

const TEAL = '#3fced1';

interface HighFinishBarsProps {
  entries: SeasonHighFinishEntry[] | null | undefined;
  title?: string;
}

/**
 * High-Finish-Verteilung als horizontale Tailwind-Balken.
 * Zeigt wie oft welcher Checkout-Wert (100-170) getroffen wurde.
 */
const HighFinishBars: React.FC<HighFinishBarsProps> = ({
  entries,
  title = 'High-Finish-Verteilung',
}) => {
  const safe = (Array.isArray(entries) ? entries : [])
    .filter((e) => e && typeof e.value === 'number' && typeof e.count === 'number' && e.count! > 0)
    .sort((a, b) => (b.value ?? 0) - (a.value ?? 0));

  const maxCount = safe.reduce((m, e) => Math.max(m, e.count ?? 0), 0);

  return (
    <Card className="bg-zinc-900 border border-zinc-800">
      <CardBody className="p-0">
        <div className="px-4 py-3 border-b border-zinc-800">
          <h3 className="text-sm font-semibold flex items-center gap-2">
            <Target size={16} style={{ color: TEAL }} />
            {title}
          </h3>
        </div>
        {safe.length === 0 ? (
          <p className="px-4 py-6 text-sm text-gray-500 text-center">
            Keine High Finishes erfasst
          </p>
        ) : (
          <ul className="p-4 space-y-2 max-h-96 overflow-y-auto">
            {safe.map((entry, idx) => {
              const count = entry.count ?? 0;
              const pct = maxCount > 0 ? Math.max(4, Math.round((count / maxCount) * 100)) : 0;
              const isMax = (entry.value ?? 0) === 170;
              return (
                <li key={`${entry.value}-${idx}`} className="flex items-center gap-3">
                  <span
                    className="w-9 text-right text-sm font-bold tabular-nums flex-shrink-0"
                    style={isMax ? { color: '#FFD700' } : { color: '#e4e4e7' }}
                  >
                    {entry.value}
                  </span>
                  <div className="flex-1 h-4 bg-zinc-800 rounded overflow-hidden">
                    <div
                      className="h-full rounded transition-all"
                      style={{
                        width: `${pct}%`,
                        backgroundColor: isMax ? '#FFD700' : TEAL,
                        opacity: isMax ? 0.9 : 0.7,
                      }}
                    />
                  </div>
                  <span className="w-8 text-xs text-gray-400 tabular-nums flex-shrink-0">
                    {count}×
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </CardBody>
    </Card>
  );
};

export default HighFinishBars;
